"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCUpIcon20Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCUpIcon20Regular = forwardRef_1.forwardRef('ArrowCUpIcon20Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M3.22 13.155a.75.75 0 0 1 0-1.06l4.836-4.836a2.75 2.75 0 0 1 3.889 0l4.836 4.835a.75.75 0 0 1-1.061 1.061L10.884 8.32a1.25 1.25 0 0 0-1.768 0L4.28 13.155a.75.75 0 0 1-1.06 0Z" })));
});
